import { render, staticRenderFns } from "./checklistRiskRegisterTL.vue?vue&type=template&id=5b683140"
import script from "./checklistRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./checklistRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b683140')) {
      api.createRecord('5b683140', component.options)
    } else {
      api.reload('5b683140', component.options)
    }
    module.hot.accept("./checklistRiskRegisterTL.vue?vue&type=template&id=5b683140", function () {
      api.rerender('5b683140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/timeline/checklistRiskRegisterTL.vue"
export default component.exports